export enum PrivateRoutes {
  ROOT = '/',
  CONTACT = '/contact',
  PRIVACY = '/privacy',
  TERMS = '/terms',
  MESSAGES = '/messages',
  SEND_MESSAGE = '/messages/send-message',
  SEND_MESSAGE_WITH_ACCOUNT = '/messages/send-message/:account',
  SHOW_MESSAGE = '/messages/show-message',
  PROFILE = '/profile',
  HISTORY = '/history',
  DOCUMENTS = '/documents',
  TRUST = '/trust/:account/:sourceRecId',
  LOAN_DETAILS = '/loan-details/:account/:sourceRecId',
  CONSTRUCTION_TRUST = '/construction-trust/:account/:sourceRecId',
  PAYMENT = '/payment/:account/:sourceRecId/:companyId/:amount',
  REQUEST_DRAW = '/request-draw/:account/:sourceRecId',
  REVIEW_DRAW = '/review-draw/:account/:sourceRecId/:drawRequestId',
  VIEW_ALL_DRAWS = '/view-all-draws/:account/:sourceRecId',
  CREATE_DRAW_MESSAGE = '/create-draw-message',
  DRAW_REQUEST_MESSAGE = '/draw-request-message',
  PAYMENT_RECEIPT = '/payment-receipt',
}
